import React from 'react';
import {recaptchaKey} from './Keys';
import { b64SafeEncode, isLocal } from './helpers';

export default new class Recaptcha {

    init() {
        if (document.getElementById('grecaptcha-js')) {
            return;
        }

        const script       = document.createElement('script');
        script.id          = 'grecaptcha-js'
        script.src         = `https://www.google.com/recaptcha/api.js?render=${recaptchaKey}`;
        script.crossorigin = true;
        script.async       = true;
        document.head.appendChild(script);

        // Preconnect to speed up captcha loading
        const gstatic       = document.createElement('link');
        gstatic.rel         = 'preconnect';
        gstatic.href        = 'https://www.gstatic.com';
        gstatic.crossorigin = true;
        document.head.appendChild(gstatic);
    }

    terms() {
        return <>
            This site is protected by reCAPTCHA and the Google &nbsp;
            <a href="https://policies.google.com/privacy" target="_blank" rel="noreferrer">Privacy Policy</a> and &nbsp;
            <a href="https://policies.google.com/terms" target="_blank" rel="noreferrer">Terms of Service</a> apply.
        </>
    }

    async getToken(action = 'submit') {
        return new Promise((resolve, reject) => {

            if (!window?.grecaptcha?.ready) {
                if (isLocal()) {
                    resolve(
                        b64SafeEncode(JSON.stringify({
                            token: 'local',
                            action,
                            hostname: window.location.hostname,
                        }))
                    );
                } else {
                    reject('There was an issue authorising your request, please refresh and try again');
                }
            }

            window.grecaptcha.ready(() => {
                window.grecaptcha.execute(recaptchaKey, {action})
                    .then((token) => {
                        resolve(
                            b64SafeEncode(JSON.stringify({
                                token,
                                action,
                                hostname: window.location.hostname,
                            }))
                        );
                    }).catch(reject)
            });
        });
    }

}()
